import { render, staticRenderFns } from "./CoverTypePage.vue?vue&type=template&id=3a804dea&scoped=true&"
import script from "./CoverTypePage.vue?vue&type=script&lang=js&"
export * from "./CoverTypePage.vue?vue&type=script&lang=js&"
import style0 from "./CoverTypePage.vue?vue&type=style&index=0&id=3a804dea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a804dea",
  null
  
)

export default component.exports